/**
 * Use this file for JavaScript code that you want to run in the front-end
 * on posts/pages that contain this block.
 *
 * When this file is defined as the value of the `viewScript` property
 * in `block.json` it will be enqueued on the front end of the site.
 *
 * Example:
 *
 * ```js
 * {
 *   "viewScript": "file:./view.js"
 * }
 * ```
 *
 * If you're not making any changes to this file because your project doesn't need any
 * JavaScript running in the front-end, then you should delete this file and remove
 * the `viewScript` property from `block.json`.
 *
 * @see https://developer.wordpress.org/block-editor/reference-guides/block-api/block-metadata/#view-script
 */

// import { __ } from '@wordpress/i18n';
function moreOffer()
{
    var currentlangage = document.getElementsByTagName('html')[0].getAttribute('lang');
    var best = document.getElementById("card-best");
    var showmore = document.getElementById("showMoreProductA");
   
    best.classList.toggle('best');
    if(showmore.innerHTML.indexOf('<i class="bi bi-plus-square-fill align-middle"></i>') != -1)
    {
        showmore.innerHTML = getVoirPlusTrad(currentlangage)['voir moins d\'offres']+' <i class="bi bi-dash-square-fill align-middle"></i>'
    }
    else
    {
        showmore.innerHTML = getVoirPlusTrad(currentlangage)['voir plus d\'offres']+' <i class="bi bi-plus-square-fill align-middle"></i>'
    }
}
window.moreOffer = moreOffer;
/* eslint-enable no-console */

function getVoirPlusTrad(langue)
{
    var txt = {'voir plus d\'offres':'voir plus d\'offres', 'voir moins d\'offres':'voir moins d\'offres' };
    switch (langue.substring(0, 2)) {
        case 'en':
            txt = {'voir plus d\'offres':'see more offers', 'voir moins d\'offres':'see less offers' };
            break;
        case 'lb':
            txt = {'voir plus d\'offres':'gesinn méi Offeren', 'voir moins d\'offres':'gesinn manner Offeren' };
            break;
        case 'nl':
            txt = {'voir plus d\'offres':'meer aanbiedingen zien', 'voir moins d\'offres':'minder aanbiedingen zien' };
            break;
        case 'pt':
            txt = {'voir plus d\'offres':'ver mais ofertas', 'voir moins d\'offres':'ver menos ofertas' };
            break;   
        default:
            txt = {'voir plus d\'offres':'voir plus d\'offres', 'voir moins d\'offres':'voir moins d\'offres' };
            break;
    }
    return txt;
}
